var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxisBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.09,
    height: 77.36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 27h1353.599v939.6H27V27z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    style: {
      fill: "#00f"
    },
    transform: "matrix(1.25 0 0 -1.25 -105.933 234.4)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-20.312l-12.333 21.507h20.309L0 0z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(152.12 128.092)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 10.185-17.516-22.498-39.086h-20.273L0 0z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(119.403 184.694)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.423 6.558L-7.014 0H0zm1.413-2.74h-9.876l-2.568-4.664h-3.763l11.438 20.499L7.666-7.404H3.853L1.413-2.74z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(164.724 157.003)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-6.367 9.191h3.969l4.419-6.505 4.621 6.505h4L3.997 0l6.985-10.066H7.075l-5.108 7.38-5.28-7.38h-3.943L0 0z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(180.114 159.665)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-3.479v19.258h3.478L0 0z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(197.702 149.6)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.841-1.409C-3.371-.644-3.867-.145-4.354.09c-.498.268-1.136.399-1.928.399-.96 0-1.758-.23-2.41-.696-.635-.444-.954-1.005-.953-1.684 0-.953.841-1.705 2.509-2.274l2.306-.795c1.874-.614 3.243-1.401 4.12-2.304C.17-8.182.588-9.295.588-10.632c0-1.765-.703-3.241-2.128-4.379-1.417-1.177-3.201-1.758-5.314-1.758-2.005 0-3.664.492-4.962 1.495-1.298 1.005-2.089 2.393-2.416 4.18l3.529.652c.168-1.139.435-1.905.846-2.343.711-.826 1.773-1.249 3.142-1.249 1.095 0 1.989.294 2.704.916.724.601 1.077 1.376 1.077 2.304 0 .372-.054.72-.204 1.02-.1.326-.298.603-.559.867a4.658 4.658 0 0 1-1.029.738c-.416.235-.914.434-1.492.663l-2.227.771c-3.178 1.11-4.742 2.738-4.742 4.888 0 1.45.666 2.644 1.986 3.615 1.318.988 2.97 1.491 4.945 1.489C-3.598 3.237-1.498 2.157 0 0",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(215.1 166.023)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.157c1.589 0 2.747.253 3.486.76.772.565 1.17 1.27 1.17 2.117 0 .838-.398 1.539-1.137 2.12-.731.526-2.025.824-3.911.824H0V0zm0 8.25h1.104c1.292 0 2.251.235 2.848.715.596.481.906 1.183.906 2.103 0 .92-.31 1.612-.924 2.062-.628.485-1.519.721-2.7.721H0V8.25zM-3.482-2.742v19.258H0c1.545 0 2.775-.086 3.694-.291a6.154 6.154 0 0 0 2.339-.999 5.523 5.523 0 0 0 1.542-1.864c.4-.719.594-1.477.594-2.232 0-1.379-.643-2.545-1.91-3.504 1.238-.347 2.194-.959 2.903-1.834.727-.861 1.081-1.857 1.081-3.028 0-1.492-.634-2.764-1.917-3.811a6.363 6.363 0 0 0-2.582-1.331c-1.051-.247-2.359-.364-3.942-.364h-5.284z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(232.834 152.341)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.436 6.558L-7.042 0H0zm1.417-2.74h-9.89l-2.571-4.664h-3.765l11.421 20.499L7.653-7.404H3.821L1.417-2.74z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(258.068 157.003)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20.597L16.837 5.872v13.386h3.488V-1.175L3.484 13.5V0H0z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(268.003 149.6)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "maroon"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 8.998 7.688h4.641L3.204-1.037l10.507-10.532H9.04L.726-2.998 0-3.6v-7.969h-3.493V7.688H0V0z",
    style: {
      fill: "maroon",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(296.137 161.168)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisBank);
export default __webpack_public_path__ + "static/media/axis-bank.4de2b77d92978cba3ef3ea8ff05af2ee.svg";
export { ForwardRef as ReactComponent };